// Swap each collection card's thumbnails for that collection's current best sellers.
(() => {
  const load = (el) => {
    if (el.dataset.loaded) return;
    el.dataset.loaded = 'true';
    fetch(el.dataset.url)
      .then((response) => (response.ok ? response.text() : Promise.reject()))
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const list = doc.querySelector('.century-thumbs');
        if (!list || !list.children.length) return;
        const limit = Number(el.dataset.limit) || 5;
        [...list.children].slice(limit).forEach((item) => item.remove());
        el.replaceChildren(list);
      })
      .catch(() => {});
  };
  const init = () => {
    const targets = document.querySelectorAll('[data-hub-thumbs]');
    if (!('IntersectionObserver' in window)) return targets.forEach(load);
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { load(entry.target); observer.unobserve(entry.target); }
      });
    }, { rootMargin: '400px 0px' });
    targets.forEach((el) => observer.observe(el));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

// Shop all row: arrows scroll the collections sideways; they show only when the row is wider than the screen.
(() => {
  const setup = (hub) => {
    const list = hub.querySelector('.century-hub__list');
    const arrows = hub.querySelector('.century-hub__arrows');
    if (!list || !arrows || arrows.dataset.ready) return;
    arrows.dataset.ready = 'true';
    const prev = arrows.querySelector('[data-hub-prev]');
    const next = arrows.querySelector('[data-hub-next]');
    const update = () => {
      const overflow = list.scrollWidth > list.clientWidth + 2;
      arrows.hidden = !overflow;
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
    };
    const step = () => {
      const item = list.querySelector('.century-hub__item');
      return item ? item.getBoundingClientRect().width + 12 : list.clientWidth * 0.8;
    };
    prev.addEventListener('click', () => list.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => list.scrollBy({ left: step(), behavior: 'smooth' }));
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };
  const init = () => document.querySelectorAll('.century-hub--all').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
